export default class {
  constructor($uibModalInstance, selected, excluded) {
    'ngInject';
    this.$uibModalInstance = $uibModalInstance;
    this.selected = selected ? {...selected} : {};
    this.excluded = excluded;
  }
  cancel() {
    this.$uibModalInstance.dismiss();
  }
  //on delete successfully just close the popup
  confirm() {
    this.$uibModalInstance.close(this.selected);
  }
}
